import React, { useEffect, useState } from 'react';
import { useLocation } from '../util/router';
import { getInsightSQCAppUrl } from '../util/cross-app-urls';

/**
 * Redirects to InsightSQC routes
 * This component handles redirects from Fuel to InsightSQC for routes that belong to InsightSQC
 */
function InsightSQCRedirect({ targetPath }) {
  const location = useLocation();
  const [insightSQCUrl, setInsightSQCUrl] = useState(null);

  useEffect(() => {
    const url = getInsightSQCAppUrl();
    setInsightSQCUrl(url);

    if (url) {
      // Use the provided targetPath or current path
      const path = targetPath || location.pathname;
      // Preserve query string if present
      const queryString = location.search || '';
      // Redirect to InsightSQC
      window.location.href = `${url}${path}${queryString}`;
    } else {
      // Can't determine InsightSQC URL - show error instead of silent redirect
      console.error('Cannot redirect to InsightSQC: URL could not be determined');
      // Don't redirect - let the error message show
    }
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: '1rem'
      }}
    >
      <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div>
      {insightSQCUrl ? (
        <p>Redirecting to InsightSQC...</p>
      ) : (
        <p style={{ color: 'red' }}>Error: Cannot connect to InsightSQC. Please contact support.</p>
      )}
    </div>
  );
}

export default InsightSQCRedirect;
